import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ObrasService from '../../../../services/obras-auth';



const Contas = () => {
    const [nome, setNome] = useState("");
    const [local, setLocal] = useState("");
    const [ano, setAno] = useState("");
    const [dataInicio, setDataInicio] = useState("");
    const [valor, setValor] = useState("");
    const [etapa, setEtapa] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [percentualConcluido, setPercentualConcluido] = useState("");
    const [situacao, setSituacao] = useState("");
    const [previsaoConclusao, setPrevisaoConclusao] = useState("");
    const [anexos, setAnexos] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const montaForm = async () => {
        const lic = new FormData();
        lic.append("nome", nome)
        lic.append("local", local)
        lic.append("ano", ano)
        lic.append("dataInicio", dataInicio)
        lic.append("valor", valor)
        lic.append("empresa", empresa)
        lic.append("etapa", etapa)
        lic.append("percentualConcluido", percentualConcluido)
        lic.append("situacao", situacao)
        lic.append("previsaoConclusao", previsaoConclusao)
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await ObrasService.cadastro(dados)
            if (lic.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                alert(lic.data["error"])
            }
        } catch (error) {
            alert(error)
        }
    }


    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setLocal("");
        setAno("");
        setEtapa("");
        setDataInicio("");
        setValor("");
        setEmpresa("");
        setPercentualConcluido("");
        setSituacao("");
        setPrevisaoConclusao("");
        setAnexos([]);
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome da Obra"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="local">
                                <FloatingLabel
                                    label="Local da Obra"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="local"
                                        value={local}
                                        onChange={e => setLocal(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicio">
                                <FloatingLabel
                                    label="Data de Início"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataInicio"
                                        value={dataInicio}
                                        onChange={e => setDataInicio(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="previsaoConclusao">
                                <FloatingLabel
                                    label="Previsão de Conclusão (Mês/Ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="previsaoConclusao"
                                        value={previsaoConclusao}
                                        onChange={e => setPrevisaoConclusao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="percentualConcluido">
                                <FloatingLabel
                                    label="% Concluído (Ex: 7%)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="percentualConcluido"
                                        value={percentualConcluido}
                                        onChange={e => setPercentualConcluido(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor da Obra">
                                <FloatingLabel
                                    label="Valor da Obra (2.000 = 2000)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Paralizada">Paralizada</option>
                                        <option value="Concluída">Concluída</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Empresa">
                                <FloatingLabel
                                    label="Empresa Responsável"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="empresa"
                                        value={empresa}
                                        onChange={e => setEmpresa(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Etapa">
                                <FloatingLabel
                                    label="Etapa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="etapa"
                                        value={etapa}
                                        onChange={e => setEtapa(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="anexo">
                                <Form.Label>Anexos</Form.Label>
                                <Fragment>
                                    <Form.Control
                                        type="file"
                                        name="anexos"
                                        onChange={handleUploadDocumentos}
                                        accept=".pdf, .xlsx, .xls"
                                        multiple // Permite múltiplos arquivos
                                    />
                                </Fragment>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/obras'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Documento cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/obras/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Documentos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/obras'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Contas;